import React from "react";
const DEFAULT_CLASSES = {
  list: "list ma0 pa0 flex flex-wrap",
  item: "flex service__container bg-white w-50 w-25-l relative mv2"
};

const ServiceLogoGrid = ({ services, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };

  const nodes = services.map((service, iconIx) => (
    <li className={classes.item} key={iconIx}>
      <div className={`image__cover--after service--${service}`}></div>
    </li>
  ));
  nodes.push(
    <li className={`${classes.item} items-center`} key="more">
      <div className="f7 pl2 black-50 w-100 tc w-auto-l">+ more</div>
    </li>
  );

  return <ul className={classes.list}>{nodes}</ul>;
};

export default ServiceLogoGrid;
